

















import Vue, { PropType } from "vue";

import Loading from "./Loading.vue";

import ModulesJson from "../../shared/ModulesJson";

export default Vue.extend({
  name: "Navigation",
  components: {
    Loading,
  },
  props: {
    items: Array as PropType<ModulesJson[]>,
    currentPage: String,
    loginPermission: Number,
  },
  data() {
    return {};
  },
  computed: {
    itemsToDisplay: function () {
      return this.items.filter((item: any) => item.isDisplayed == true);
    },
  },
  methods: {},
});
